( $ => {

    $('.js-ScrollTo').click( function (e) {
        e.preventDefault()

        let target = this.hash,
            $target = $(target),
            targetOffset = $target.offset().top

        let headerHeight = $('.header').outerHeight(),
            scrollOffset = (targetOffset - headerHeight)

        $('html, body').animate({
            'scrollTop': scrollOffset
        }, 800)

    })

} )(jQuery)